import { trackEvent } from "@/lib/analytics";
import { measureOpenAiLead } from "@/lib/openAiPixel";
import { ANALYSIS_SIGNUP_TARGET } from "@/config/analysisOffer";
import type { AnalysisEntryContext } from "@appcaire/shared/analysis/analysisEntry";

/**
 * Marketing CTA click tracking.
 *
 * Extracted so the landing page and any other marketing surface report the
 * same event shape — `BrandHomeExperience` grew a private copy of this, and a
 * second private copy is how `cta_id` values start disagreeing between pages
 * and the funnel report stops adding up.
 *
 * A click that leaves for the free-analysis sign-up also records
 * `free_analysis_start`, the conversion to mark as a GA4 key event. It is a
 * named event rather than a GA4 rule over `cta_click` parameters, so the
 * conversion cannot silently stop matching when a parameter is renamed.
 */
export function trackMarketingCta(
  ctaId: string,
  ctaLabel: string,
  target: string,
  analysisContext?: AnalysisEntryContext,
): void {
  const analysisParams = analysisContext
    ? {
        intent: "analysis",
        locale: analysisContext.locale,
        analysis_source: analysisContext.source,
        analysis_medium: analysisContext.medium,
        analysis_landing: analysisContext.landing,
        analysis_entry_cta: analysisContext.cta,
        analysis_campaign: analysisContext.campaign,
      }
    : {};
  const pagePath =
    typeof window === "undefined" ? "" : window.location.pathname;
  trackEvent("cta_click", {
    cta_id: ctaId,
    cta_label: ctaLabel,
    target,
    page_path: pagePath,
    ...analysisParams,
  });
  if (analysisContext && target === ANALYSIS_SIGNUP_TARGET) {
    trackEvent("free_analysis_start", {
      cta_id: ctaId,
      page_path: pagePath,
      ...analysisParams,
    });
    measureOpenAiLead();
  }
}
